import { render } from "./SuccessOverlay.vue?vue&type=template&id=2e8727fa"
import script from "./SuccessOverlay.vue?vue&type=script&lang=ts"
export * from "./SuccessOverlay.vue?vue&type=script&lang=ts"
script.render = render

export default script